import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addProductItem } from '../../../redux/ProductItem/actioCreators';

function ProductInputForm() {
  // local state management to handle data
  const [productName, setProductName] = useState('');
  const [productCategory, setProductCategory] = useState('');
  const [productImage, setProductImage] = useState('');
  const [productPrice, setProductPrice] = useState('');
  const [productQuantity, setProductQuantity] = useState('');

  // useDispatch function to dispatch action to the redux store
  const dispatch = useDispatch();

  const addProductHandler = e => {
    e.preventDefault();
    // dispatch action to the redux store
    dispatch(
      addProductItem({
        productName,
        productCategory,
        productImage,
        productPrice: parseInt(productPrice),
        productQuantity: parseInt(productQuantity),
        defaultProductQuantity: parseInt(productQuantity),
      })
    );

    setProductName('');
    setProductCategory('');
    setProductImage('');
    setProductQuantity('');
    setProductPrice('');
  };

  return (
    <div>
      {/* <!-- Product Input Form --> */}
      <div className="formContainer">
        <h4 className="formTitle">Add New Product</h4>
        <form
          className="space-y-4 text-[#534F4F]"
          id="lws-addProductForm"
          onSubmit={addProductHandler}
        >
          {/* <!-- product name --> */}
          <div className="space-y-2">
            <label htmlFor="lws-inputName">Product Name</label>
            <input
              className="addProductInput"
              id="lws-inputName"
              type="text"
              required
              value={productName}
              onChange={e => setProductName(e.target.value)}
            />
          </div>
          {/* <!-- product category --> */}
          <div className="space-y-2">
            <label htmlFor="lws-inputCategory">Category</label>
            <input
              className="addProductInput"
              id="lws-inputCategory"
              type="text"
              required
              value={productCategory}
              onChange={e => setProductCategory(e.target.value)}
            />
          </div>
          {/* <!-- product image url --> */}
          <div className="space-y-2">
            <label htmlFor="lws-inputImage">Image Url</label>
            <input
              className="addProductInput"
              id="lws-inputImage"
              type="text"
              required
              value={productImage}
              onChange={e => setProductImage(e.target.value)}
            />
          </div>
          {/* <!-- price & quantity container --> */}
          <div className="grid grid-cols-2 gap-8 pb-4">
            {/* <!-- price --> */}
            <div className="space-y-2">
              <label htmlFor="ws-inputPrice">Price</label>
              <input
                className="addProductInput"
                type="number"
                id="lws-inputPrice"
                required
                value={productPrice}
                onChange={e => setProductPrice(e.target.value)}
              />
            </div>
            {/* <!-- quantity --> */}
            <div className="space-y-2">
              <label htmlFor="lws-inputQuantity">Quantity</label>
              <input
                className="addProductInput"
                type="number"
                id="lws-inputQuantity"
                required
                value={productQuantity}
                onChange={e => setProductQuantity(e.target.value)}
              />
            </div>
          </div>
          {/* <!-- submit button --> */}
          <button type="submit" id="lws-inputSubmit" className="submit">
            Add Product
          </button>
        </form>
      </div>
      {/* <!-- Product Input Form Ends --> */}
    </div>
  );
}

export default ProductInputForm;
